import * as yup from "yup";
import { mobileNoExp } from "../../../../../../utils/regularExpressions";

const emailRegex = /^[A-Za-z0-9._%+]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

const panRegex = /^[A-Z]{3}P[A-Z][0-9]{4}[A-Z]$/;

const nameRegex = /^[A-Za-z\s]+$/;

const carOwnerSchema = (product) =>
  yup.object().shape({
    owner_type: yup.string().required("Owner type is required"),

    company_name: yup.string().when("owner_type", {
      is: "COMP",
      then: () =>
        yup
          .string()
          .required("Company Name is required")
          .min(2, "Company name is too short")
          .max(100, "Company name is too long"),
      otherwise: () => yup.string().nullable(),
    }),

    first_name: yup
      .string()
      .required("First Name is required")
      .matches(nameRegex, "First name should contain only letters")
      .min(2, "First name is too short")
      .max(50, "First name is too long"),

    last_name: yup
      .string()
      .required("Last Name is required")
      .matches(nameRegex, "Last name should contain only letters")
      .min(1, "Last name is too short")
      .max(50, "Last name is too long"),

    email: yup
      .string()
      .required("Email is required")
      .matches(emailRegex, "Please enter a valid email address")
      .max(100, "Email is too long"),

    mobile_no: yup
      .string()
      .required("Mobile no. is required")
      .matches(/^[6-9]\d{9}$/, "Please enter a valid 10 digit mobile number"),

    pan_no: yup.string().when("company_slug", {
      is: "hdfc_ergo",
      then: () =>
        yup
          .string()
          .required("Pan no. is required")
          .matches(panRegex, "Please enter a valid PAN number"),

      otherwise: () =>
        yup
          .string()
          .nullable()
          .matches(/^$|^[A-Z]{3}P[A-Z][0-9]{4}[A-Z]$/, "Please enter a valid PAN number"),
    }),

    is_pa: yup.boolean().nullable(),

    company_slug: yup.string().nullable(),
  });

export default carOwnerSchema;